import { CloseCircleFilled } from "@ant-design/icons";
import React from "react";

export default function SearchTag({ tag_name, index, onRemoveFilter, type }) {
  return (
    <div className="search-tag-container">
      <div className="tag-content">
        <div style={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{tag_name}</div>
        <div style={{ position: "absolute", right: -10, top: -10 }}>
          <CloseCircleFilled onClick={() => onRemoveFilter(index, type)} style={{ fontSize: 24, color: "black", backgroundColor: "#90c7c5", borderRadius: "50%", cursor: "pointer" }} />
        </div>
      </div>
    </div>
  );
}
